import React, { useState } from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { RainfallSettingArray, PastRainDataListType } from "../types/type";
import { SettingTable } from "./SettingTable";

type Props = {
  modalMode: string;
  setDataListState: any;
  setModalType: any;
  pastWaterLevel: any;
  pastRainfall: any;
  pastFutureInputData: any;
  setPastWaterLevel: any;
  setPastRainfall: any;
  setPastFutureInputData: any;
  // savedData: RainfallSettingArray;
  PastRainDataList: PastRainDataListType;
  getPastData: any;
  // referenceTime: any;
  postPastRainDataInsert: any;
  // setSavedData: any;
  postRunSimulation: any;
  getSimulationsList: any;
  maxRainfall: number;
  maxFutureRainfall: number;
  dataListState: RainfallSettingArray;
  user: any;
};

export const PastFutureDataSetting = (props: Props) => {
  const {
    modalMode,
    setModalType,
    setDataListState,
    // savedData,
    // referenceTime,
    pastWaterLevel,
    pastRainfall,
    pastFutureInputData,
    setPastWaterLevel,
    setPastRainfall,
    setPastFutureInputData,
    postPastRainDataInsert,
    PastRainDataList,
    getPastData,
    // setSavedData,
    postRunSimulation,
    getSimulationsList,
    maxRainfall,
    maxFutureRainfall,
    dataListState,
    user,
  } = props;
  const handlerClickDownload = (e: any, type: string) => {
    e.preventDefault();
    const csvData = [];
    // console.log("★pastRainfall = ", pastRainfall);
    if (type === "csv") {
      csvData.push(["時間", "過去降雨量"]);
      pastRainfall.forEach((obj: any) => {
        csvData.push([obj.data_create_time as string, obj.input_data]);
      });
      const fileName = "pastrainfall.csv";
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, csvData.join("\n")], {
        type: "text/csv",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      link.remove();
    }
  };
  const handlerClickaUpload = (e: any) => {
    e.preventDefault();
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".csv";
    // csvファイルの読込み後に、postPastRainDataInsertを実行する
    const PastRainDataList: PastRainDataListType = [];
    input.onchange = (event: any) => {
      const file = event.target.files[0];
      const reader = new FileReader();
      const PastRainDataList: PastRainDataListType = [];
      reader.readAsText(file);
      reader.onload = () => {
        const csvData = reader.result;
        // console.log("★csvData = ", csvData);
        const csvArray = (csvData as string)
          ?.replace(/\r\n/g, "\n")
          .split("\n");
        csvArray?.forEach((row: any, index: number) => {
          if (index !== 0 && row !== "") {
            const rowData = row.split(",");
            // dateとfloatのチェック
            if (
              isNaN(Date.parse(rowData[0])) ||
              isNaN(parseFloat(rowData[1]))
            ) {
              alert("アップロードしたデータに誤りがあります。");
              return;
            } else {
              // yyyy-mm-dd hh:00形式に強制的に文字列変換
              const date = new Date(rowData[0]);
              const yaer_str = date.getFullYear();
              const month_str = 1 + date.getMonth();
              const day_str = date.getDate();
              const hour_str = date.getHours();
              const newdate =
                yaer_str +
                "-" +
                ("0" + month_str).slice(-2) +
                "-" +
                ("0" + day_str).slice(-2) +
                " " +
                ("0" + hour_str).slice(-2) +
                ":00";
              // const newdate = rowData[0].replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4:$5');
              // console.log("★newdate = ", newdate);
              const rainfallData = {
                data_create_time: newdate,
                past_rain_amount: rowData[1],
                sensor_id: pastRainfall[0].sensor_id,
              };
              // console.log("★rainfallData = ", rainfallData);
              PastRainDataList.push(rainfallData);
              // console.log("★1PastRainDataList = ", PastRainDataList);}
            }
          }
        });
      };
      // csvファイルの読込後に、postPastRainDataInsertを実行する
      reader.onloadend = async () => {
        // console.log("★PastRainDataList = ", PastRainDataList);
        // アップロードしたデータが存在する場合
        if (PastRainDataList.length > 0) {
          // DB登録
          await postPastRainDataInsert(PastRainDataList);
          // データ取得
          await getPastData();
          setModalType("pastFutureData");
        } else {
          alert("アップロードしたデータが存在しません。");
        }
      };
    };
    input.click();
    return PastRainDataList;
  };

  return (
    <>
      <div className="flex items-center">
        <table className="border w-full text-sm text-left text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="px-6 py-3 text-center">
                過去水位
              </th>
              <th scope="col" className="px-6 py-3 text-center">
                過去降雨量
              </th>
              <th scope="col" className="px-6 py-3 text-center">
                予測降雨量
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="whitespace-nowrap">
              <td className="border px-2 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                <div className="">
                  {/* modalModeが"reference"の場合modeに"reference"を、"edit"の場合にmodeに"edit"を渡す */}
                  {modalMode === "reference" ? (
                    <SettingTable
                      type="waterLevel"
                      mode="reference"
                      settingData={pastWaterLevel}
                      setSettingData={setPastWaterLevel}
                    />
                  ) : (
                    <SettingTable
                      type="waterLevel"
                      mode="edit"
                      settingData={pastWaterLevel}
                      setSettingData={setPastWaterLevel}
                    />
                  )}
                </div>
              </td>
              <td className="border px-2 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                <div>
                  {/* modalModeが"edit"の場合は、buttonを表示にする。 */}
                  {modalMode === "edit" ? (
                    <div className="flex items-center">
                      {/* modalModeが"reference"の場合は、buttonをdisableに設定 */}
                      <button
                        type="button"
                        className="w-fit flex items-center justify-between text-planeText focus:outline-none text-white bg-settingWindowMain
                                focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-planeText px-1 py-1 dark:bg-purple-600 hover:bg-ArithmerBlue"
                        onClick={(e) => handlerClickDownload(e, "csv")}
                      >
                        <div className="flex items-center">
                          <img
                            src="./img/downloading_white.png"
                            className="w-[30px]"
                          ></img>
                          <p className="pl-2">
                            過去雨量CSV<br></br>ファイルダウンロード
                          </p>
                        </div>
                      </button>
                      <button
                        type="button"
                        className="w-fit flex items-center justify-between text-planeText focus:outline-none text-white bg-settingWindowMain
                                focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-planeText px-1 py-1 dark:bg-purple-600 hover:bg-ArithmerBlue"
                        onClick={(e) => {
                          handlerClickaUpload(e);
                        }}
                      >
                        <div className="flex items-center">
                          <img
                            src="./img/upload_white.png"
                            className="w-[30px]"
                          ></img>
                          <p className="pl-2">
                            過去雨量CSVファイル<br></br>アップロード&登録
                          </p>
                        </div>
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="overflow-y-scroll max-h-[300px]">
                    {/* modalModeが"reference"の場合modeに"reference"を、"edit"の場合にmodeに"edit"を渡す */}
                    {modalMode === "reference" ? (
                      <SettingTable
                        type="rainfall"
                        mode="reference"
                        settingData={pastRainfall}
                        setSettingData={setPastRainfall}
                      />
                    ) : (
                      <SettingTable
                        type="rainfall"
                        mode="edit"
                        settingData={pastRainfall}
                        setSettingData={setPastRainfall}
                      />
                    )}
                  </div>
                </div>
              </td>
              {/** save the input data */}
              <td className="border px-2 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                <div>
                  {/* <h2 className="text-gray-800 font-bold">予測雨量</h2> */}
                  {/* <div className="flex items-center justify-around"> */}
                  <div className="flex items-center">
                    <div className="relative">
                      {/* modalModeが"reference"の場合modeに"reference"を、"edit"の場合にmodeに"edit"を渡す */}
                      {modalMode === "reference" ? (
                        <SettingTable
                          type="rainfall"
                          mode="reference"
                          settingData={dataListState}
                          setSettingData={setDataListState}
                        />
                      ) : (
                        <SettingTable
                          type="rainfall"
                          mode="edit"
                          settingData={dataListState}
                          setSettingData={setDataListState}
                        />
                      )}
                    </div>
                    <LineChart
                      width={500}
                      height={280}
                      margin={{
                        top: 5,
                        right: 5,
                        left: 5,
                        bottom: 5,
                      }}
                    >
                      <XAxis
                        dataKey="input_after_hour"
                        tick={{ fontSize: 10 }}
                        // label="日時"
                        xAxisId="future_x"
                      />
                      <YAxis
                        // dataKey="input_rain_amount"
                        type="number"
                        domain={[0, maxFutureRainfall]}
                        tick={{ fontSize: 10 }}
                        label={{
                          value: "降雨量(mm/hr)",
                          angle: -90,
                          position: "insideLeft",
                        }}
                        yAxisId="past_future_y"
                      />
                      <Tooltip />
                      <CartesianGrid stroke="#f5f5f5" />
                      <Legend />
                      <Line
                        data={dataListState}
                        name="予測降雨量"
                        type="linear"
                        dataKey="input_rain_amount"
                        stroke="#8884d8"
                        xAxisId="future_x"
                        yAxisId="past_future_y"
                      />
                    </LineChart>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={3}>
                <div className="container">
                  <LineChart
                    width={1500}
                    height={300}
                    margin={{
                      top: 5,
                      right: 5,
                      left: 5,
                      bottom: 5,
                    }}
                  >
                    <XAxis
                      dataKey="data_create_time"
                      tick={{ fontSize: 10 }}
                      // label="日時"
                      xAxisId="past_x"
                    />
                    <YAxis
                      // dataKey="input_rain_amount"
                      type="number"
                      domain={[0, maxRainfall]}
                      tick={{ fontSize: 10 }}
                      label={{
                        value: "降雨量(mm/hr)",
                        angle: -90,
                        position: "insideLeft",
                      }}
                      yAxisId="past_future_y"
                    />
                    <Tooltip />
                    <CartesianGrid stroke="#f5f5f5" />
                    <Legend />
                    <Line
                      data={[...pastRainfall].reverse()}
                      name="過去降雨量"
                      type="linear"
                      dataKey="input_data"
                      stroke="#82ca9d"
                      xAxisId="past_x"
                      yAxisId="past_future_y"
                    />
                  </LineChart>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
